var $e17d709a92ce4022$exports = {};
$e17d709a92ce4022$exports = {
    "info": `Inform\xe1cie`,
    "negative": `Chyba`,
    "notice": `Upozornenie`,
    "positive": `\xdaspech`
};


export {$e17d709a92ce4022$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
